import { createTheme } from '@mui/material/styles';
import { normalize } from '@main/normalize';

// A custom theme for this app
export const theme = createTheme({
  components: {
    MuiCssBaseline: {
      styleOverrides: normalize
    }
  },
  palette: {
    primary: {
      main: '#165788'
    },
    secondary: {
      main: '#f1f1f1'
    }
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 768,
      md: 960,
      lg: 1200,
      xl: 1440
    }
  }
});
